import axios from "axios";

if (!process.env.REACT_APP_API_URL) {
  console.warn(
    "REACT_APP_API_URL is not set. API requests will use relative URLs."
  );
}

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export default api;
